<h1 mat-dialog-title>Удаление цели</h1>
<div mat-dialog-content>
    Вы уверены, что хотите удалить цель "{{goalName}}"?
</div>
<div mat-dialog-actions class="buttons-div">
    <button mat-dialog-close class="main-button action-button">Отмена</button>
    <button mat-dialog-close class="main-button action-button delete-button" (click)="confirmDelete()">Удалить</button>
</div>